<template>
  <yield title="AGBs">
    <h1>
      Allgemeinen Geschäftsbedingungen
    </h1>

    <div>
      Die nachfolgenden Allgemeinen Geschäftsbedingungen der Outleap GmbH & Co. KG (nachfolgend "Betreiber" genannt) regeln die Bedingungen für die Nutzung der unter www.jagdnews.de angebotenen Online-Plattform (nachfolgend "Portal" genannt) durch Endnutzer (nachfolgend "Nutzer" genannt).
      
      <br><br>
      <h3>
        1. Geltungsbereich
      </h3>

      <ol>
        <li>
          Diese Allgemeinen Geschäftsbedingungen (im Folgenden "AGB") regeln die Nutzung des Portals durch Nutzer abschließend.
        </li>
        <li>
          Für bestimmte Anwendungen kann der Betreiber mit Nutzern ergänzende oder abweichende AGB vereinbaren. Auf diese wird der Betreiber jeweils deutlich und rechtzeitig vor der Nutzung der jeweiligen Anwendung hinweisen.
        </li>
      </ol>

        <h3>
          2. Account und Registrierung
        </h3>

        <ol>
          <li>
            Die Nutzung des Portals erfordert eine Registrierung durch den Nutzer und die Einrichtung eines Accounts. Sowohl die Registrierung als auch die Nutzung des Accounts ist kostenlos. Pro Nutzer ist jeweils nur ein Account zulässig, welcher nicht übertragbar ist. Nutzer haben gegenüber dem Betreiber keinen Anspruch auf Zuteilung eines Accounts.
          </li>
          <li>
            Nutzer dürfen sich nur registrieren, wenn sie das 16. Lebensjahr vollendet haben.
          </li>
          <li>
            Nutzer sind berechtigt ihren für andere Nutzer sichtbaren Benutzernamen frei zu wählen, sofern sie dadurch nicht gegen Bestimmungen dieser AGB, insbesondere die Regelungen in Ziffer 8 verstoßen. Die Anmeldung erfolgt mittels einer gültigen bei der Registrierung angegebenen Emailadresse.
          </li>
          <li>
            Die Verwendung einer sog. Wegwerf-E-Mail-Adresse zur Erstellung eines Benutzerkontos ist untersagt. Benutzerkonten, die eine solche E-Mail-Adresse verwenden, werden umgehend aus dem System entfernt.
          </li>
          <li>
            Nutzer sind verpflichtet, bei der Registrierung wahrheitsgemäße, aktuelle und vollständige Angaben nach den Vorgaben des Registrierungsformulars zu machen und ihre Angaben stets aktuell zu halten. Nutzer dürfen sich bei der Registrierung insbesondere nicht als eine andere Person ausgeben.
          </li>
          <li>
            Sind die Angaben im Registrierungsformolar aus Sicht des Betreibers vollständig und plausibel, schaltet der Betreiber den Zugang frei und benachrichtigt den Nutzer hierüber per E-Mail. Ab Zugang der E-Mail ist der Nutzer zur Nutzung des Portals im Rahmen dieser AGB für die Dauer der Gültigkeit des Accounts berechtigt. Hierzu ist der Account durch Anklicken des in der E-Mail enthaltenen Links zunächst freizuschalten.
          </li>
          <li>
            Nutzer sind verpflichtet, sicherzustellen, dass das Nutzerkonto nur von ihnen selbst genutzt wird und müssen zu diesem Zweck ihre Zugangskennung geheim halten. Eine Weitergabe an Dritte ist nicht gestattet. Der Inhaber eines Nutzerkontos ist in vollem Umfang für alle Aktivitäten, die über sein Nutzerkonto ausgeübt werden, verantwortlich. Sollte die Zugangskennung Unbefugten bekannt geworden sein, ist der Nutzer gehalten, sein Passwort unverzüglich zu ändern.
          </li>
        </ol>

        <h3>
          3. Dienste und Inhalte auf dem Portal
        </h3>

        <ol>
          <li>
            Registrierte Nutzer erhalten Zugang zu dem Portal sowie zu den auf dem Portal jeweils verfügbaren Diensten und Funktionen im Rahmen der Regelungen dieser AGB für die Dauer des ihnen zur Verfügung gestellten Accounts. Der Zugang ist unentgeltlich.
          </li>
          <li>
            Der Betreiber stellt auf dem Portal unterschiedliche Kommunikations- und sonstige Dienste zur zeitlich befristeten Nutzung zur Verfügung. Solche Dienste können z.B. das Verfügbarmachen von Beiträgen, Bild- und Tondokumenten, Informationen und sonstigen Inhalten (nachfolgend zusammenfassend "Inhalte" genannt) sowie die Bereitstellung von Plattformfunktionen sein, die beispielsweise den Austausch mit anderen Nutzern ermöglichen.
          </li>
          <li>
            Inhalt und Umfang der Dienste bestimmen sich nach den jeweils aktuell auf dem Portal verfügbaren Funktionalitäten.
          </li>
          <li>
            Der Nutzer hat keinen Anspruch auf permanente Verfügbarkeit des Portals und/oder die Bereitstellung bzw. Aufrechterhaltung von Diensten und Funktionalitäten.
          </li>
        </ol>

        <h3>
          4. Verantwortlichkeit für Inhalte Dritter
        </h3>

        Die auf dem Portal verfügbaren Inhalte stammen teilweise von dem Betreiber und teilweise von Nutzern bzw. sonstigen Dritten. Inhalte der Nutzer sowie sonstiger Dritter werden nachfolgend zusammenfassend "Drittinhalte" genannt. Der Betreiber führt bei Drittinhalten keine Prüfung auf Vollständigkeit, Richtigkeit und Rechtmäßigkeit durch und übernimmt daher keinerlei Verantwortung oder Gewährleistung für die Vollständigkeit, Richtigkeit, Rechtmäßigkeit und Aktualität der Drittinhalte. Dies gilt auch im Hinblick auf die Qualität der Drittinhalte und deren Eignung für einen bestimmten Zweck, und auch, soweit es sich um Drittinhalte auf verlinkten externen Webseiten handelt.

        <h3>
          5. Erstellung von Benutzerprofilen
        </h3>

        <ol>
          <li>
            Soweit als Funktionalität auf dem Portal verfügbar, können Nutzer Ihr Benutzerprofil im Rahmen dieser AGB nach Ihren Vorstellungen individuell gestalten. Dabei sind insbesondere die Beschränkungen in Ziffer 8. zu beachten.
          </li>
          <li>
            Der Betreiber führt im Regelfall keine Überprüfung der Identität der Profilinhaber und der Angaben in den Profilen durch. Der Betreiber leistet daher keine Gewähr dafür, dass es sich bei jedem Profilinhaber jeweils um die Person handelt, für die der jeweilige Profilinhaber sich ausgibt.
          </li>
        </ol>


        <h3>
          6. Einstellen von Nutzerinhalten
        </h3>

        <ol>
          <li>
            Soweit als Funktionalität auf dem Portal verfügbar, dürfen Nutzer unter Beachtung der Bestimmungen dieser AGB Inhalte auf dem Portal einstellen und damit für Dritte verfügbar machen.
          </li>
          <li>
            Mit dem Einstellen von Inhalten räumt der Nutzer dem Betreiber jeweils ein unentgeltliches Nutzungsrecht an den jeweiligen Inhalten für Zwecke der Bereitstellung des Portals ein, insbesondere

            <ol>
              <li>
                zur Speicherung der Inhalte auf dem von dem Betreiber eingesetzten Server sowie deren Veröffentlichung, insbesondere deren öffentlicher Zugänglichmachung (z.B. durch Anzeige der Inhalte auf dem Portal),
              </li>
              <li>
                zur Bearbeitung und Vervielfältigung, soweit dies für die Vorhaltung bzw. Veröffentlichung der jeweiligen Inhalte erforderlich ist.
              </li>
            </ol>
          </li>
          <li>
            Der Nutzer räumt dem Betreiber hinsichtlich von ihm auf dem Portal geäußerter Ideen, Problemlösungen und Konzepte sowie sonstigem Feedback das übertragbare, nicht ausschließliche Recht ein, diese kommerziell zu nutzen, insbesondere zur Entwicklung bzw. Weiterentwicklung von Produkten zu verwenden.
          </li>
          <li>
            Nutzer sind für die von Ihnen eingestellten Inhalte voll verantwortlich. Der Betreiber übernimmt keine Überprüfung der Inhalte auf Vollständigkeit, Richtigkeit, Rechtmäßigkeit, Aktualität, Qualität und Eignung für einen bestimmten Zweck.
          </li>
          <li>
            Mit dem Einstellen von Inhalten erklärt und gewährleistet der Nutzer gegenüber dem Betreiber, dass er der alleinige Inhaber sämtlicher Rechte an den von ihnen auf dem Portal eingestellten Inhalten ist,  oder aber anderweitig berechtigt ist (z.B. durch eine wirksame Erlaubnis des Rechteinhabers), die Inhalte auf dem Portal einzustellen und die Nutzungs- und Verwertungsrechte nach der vorstehenden Ziffer 6.2 zu gewähren.
          </li>
          <li>
            Der Betreiber behält sich das Recht vor, das Einstellen von Inhalten abzulehnen und/oder bereits eingestellte Inhalte ohne vorherige Ankündigung zu bearbeiten, zu sperren oder zu entfernen, sofern das Einstellen der Inhalte durch den Nutzer oder die eingestellten Inhalte selbst zu einem Verstoß gegen diese AGB geführt hat oder konkrete Anhaltspunkte dafür vorliegen, dass es zu einem Verstoß gegen diese AGB kommen wird. Der Betreiber wird hierbei jedoch auf die berechtigten Interessen des Nutzers Rücksicht nehmen.
          </li>
        </ol>

        <h3>
          7. Nutzungsrechte
        </h3>
        Soweit nicht in diesen AGB oder auf dem Portal eine weitergehende Nutzung ausdrücklich erlaubt oder auf dem Portal durch eine entsprechende Funktionalität (z.B. Download-Button) ermöglicht wird,

        <ol>
          <li>
            dürfen die auf dem Portal verfügbaren Inhalte ausschließlich für persönliche Zwecke online abgerufen und angezeigt werden. Dieses Nutzungsrecht ist auf die Laufzeit des Accounts beschränkt;
          </li>
          <li>
            ist es Nutzern untersagt, die auf dem Portal verfügbaren Inhalte ganz oder teilweise zu bearbeiten, zu verändern, zu übersetzen, zu veröffentlichen, zu vervielfältigen und/oder zu verbreiten.
          </li>
        </ol>

        <h3>
          8. Untersagte Aktivitäten
        </h3>
        <ol>
          <li>
            Die auf dem Portal verfügbaren Dienste sind ausschließlich für die nichtkommerzielle Nutzung durch die Nutzer bestimmt. Jede Nutzung für oder im Zusammenhang mit kommerziellen Zwecken ist untersagt. Zur unerlaubten kommerziellen Nutzung zählen insbesondere:

            <ol>
              <li>
                alle Angebote und Bewerbungen entgeltlicher Inhalte, Dienste und/oder Produkte;
              </li>
              <li>
                alle Angebote, Bewerbungen und Durchführungen von Aktivitäten mit kommerziellem Hintergrund wie beispielsweise Preisausschreiben, Verlosungen, Tauschgeschäfte, Inserate oder Schneeballsysteme, und
              </li>
              <li>
                jedwede Erhebung von personenbezogenen Daten (einschließlich E-Mail-Adressen) von Nutzern (z.B. für den Versand von Werbe-E-Mails).
              </li>
            </ol>
          </li>
          <li>
            Nutzern sind jegliche Aktivitäten auf bzw. im Zusammenhang mit dem Portal untersagt, die gegen geltendes Recht verstoßen und/oder Rechte Dritter verletzen. Insbesondere sind folgende Handlungen untersagt:

            <ol>
              <li>
                das Einstellen, das Verbreiten, das Angebot und die Bewerbung von Inhalten, die gegen Jugendschutzgesetze, gegen Datenschutzrecht und/oder gegen sonstiges Recht verstoßen;
              </li>
              <li>
                die Verwendung von Inhalten, durch die andere Nutzer oder Dritte beleidigt, verunglimpft, herabgewürdigt oder verleumdet werden;
              </li>
              <li>
                die Nutzung, das Bereitstellen und das Verbreiten von Inhalten, die mit Rechten Dritter (wie z.B. Marken- und Urheberrechte) belastet sind, ohne hierzu ausdrücklich berechtigt zu sein.
              </li>
            </ol>
          </li>

          <li>
            Des Weiteren sind Nutzern auch unabhängig von einem eventuellen Gesetzesverstoß bei der Einstellung eigener Inhalte auf dem Portal sowie bei der Kommunikation mit anderen Nutzern die folgenden Aktivitäten untersagt:

            <ol>
              <li>
                die Verbreitung von Viren, Trojanern und anderen schädlichen Dateien;
              </li>
              <li>
                die Versendung von Spam-Mails sowie von Kettenbriefen;
              </li>
              <li>
                die Verbreitung anzüglicher, anstößiger, sexuell geprägter, obszöner oder diffamierender Inhalte bzw. Kommunikation sowie solcher Inhalte bzw. Kommunikation die geeignet sind/ist, Rassismus, Hass, körperliche Gewalt oder rechtswidrige Handlungen zu fördern bzw. zu unterstützen;
              </li>
              <li>
                die Belästigung anderer Nutzer, z.B. durch mehrfaches persönliches Kontaktieren ohne oder entgegen der Reaktion des anderen Nutzers sowie das Fördern bzw. Unterstützen derartiger Belästigungen;
              </li>
              <li>
                die Aufforderung anderer Nutzer zur Preisgabe von Kennwörtern oder personenbezogener Daten für kommerzielle oder rechtswidrige Zwecke.
              </li>
            </ol>
          </li>
        </ol>


        <h3>
          9. Sperrung von Zugängen
        </h3>
        <ol>
          <li>
            Der Betreiber ist berechtigt, den Zugang von Nutzern zu dem Portal vorübergehend oder dauerhaft zu sperren, wenn konkrete Anhaltspunkte vorliegen, dass der jeweilige Nutzer gegen diese AGB und/oder geltendes Recht verstößt bzw. verstoßen hat. Bei der Entscheidung über eine Sperrung wird der Betreiber die berechtigten Interessen des Nutzers angemessen berücksichtigen.
          </li>
          <li>
            Im Falle der vorübergehenden bzw. dauerhaften Sperrung sperrt der Betreiber die Zugangsberechtigung und benachrichtigt den betroffenen Nutzer hierüber per E-Mail.
          </li>
          <li>
            Im Falle einer vorübergehenden Sperrung reaktiviert der Betreiber nach Ablauf der Sperrzeit die Zugangsberechtigung und benachrichtigt den betroffenen Nutzer hierüber per E-Mail. Eine dauerhaft gesperrte Zugangsberechtigung wird nicht wiederhergestellt. Dauerhaft gesperrte Personen sind von der Teilnahme an dem Portal dauerhaft ausgeschlossen.
          </li>
        </ol>

        <h3>
          10. Beendigung der Teilnahme
        </h3>
        <ol>
          <li>
            Der Nutzer ist berechtigt, seine Mitgliedschaft beim Portal jederzeit ohne Angabe von Gründen durch Mitteilung an den Betreiber zu beenden und seinen Account zu löschen.
          </li>
          <li>
            Der Betreiber ist berechtigt, die Bereitstellung des Portals jederzeit einzustellen. Unabhängig davon ist der Betreiber berechtigt, Nutzer unter den in Ziffer 9. geregelten Voraussetzungen vorübergehend oder dauerhaft von der Nutzung des Portals auszuschließen.
          </li>
          <li>
            Der Betreiber ist berechtigt, nach Löschung eines Accounts auch sämtliche im Rahmen der Teilnahme entstandenen Daten des Nutzers dieses Accounts unwiederbringlich zu löschen.
          </li>
        </ol>

        <h3>
          11. Datenschutz
        </h3>
        Art, Umfang und Zwecke der Erhebung und Verwendung der für die Registrierung und die Nutzung der Plattform erforderlichen personenbezogenen Daten ergeben sich aus den Datenschutzhinweisen, die <router-link to="/privacy">hier zu finden</router-link> sind.


        <h3>
          12. Haftung
        </h3>
        Der Betreiber haftet nur bei Vorsatz und grober Fahrlässigkeit. Die vorstehende Haftungsbeschränkung gilt auch im Falle des Verschuldens eines Erfüllungsgehilfen von dem Betreiber sowie für die persönliche Haftung der Mitarbeiter, Vertreter und Organe des Betreibers.

        <h3>
          13. Änderung der AGB
        </h3>
        Der Betreiber behält sich das Recht vor, diese AGB jederzeit mit Wirkung für die Zukunft zu ändern. Widerspricht der Nutzer solchen Änderungen nicht innerhalb von vier Wochen nach Zugang der Mitteilung, gelten die Änderungen als vereinbart. Für den Änderungsfall verpflichtet sich der Betreiber, dem Nutzer die Änderungen der AGB per E-Mail mitzuteilen und ihn dabei darauf hinzuweisen, dass die Änderungen als akzeptiert gelten, wenn er nicht binnen vier Wochen seit Erhalt der E-Mail widerspricht.

        <h3>
          14. Schlussbestimmungen
        </h3>

        <ol>
          <li>
            Mündliche Nebenabreden sind nicht getroffen.
          </li>
          <li>
            Es gilt das Recht der Bundesrepublik Deutschland.
          </li>
        </ol>


      <br><br>
      Stand: Januar 2018
    </div>
  </yield>
</template>

<script>
  import Yield from '@/vues/helpers/yield.vue';

  export default {
    name: 'Terms',
    components: { Yield }
  };
</script>
